import { render, staticRenderFns } from "./ClientDropdown.vue?vue&type=template&id=a4118a70&"
import script from "./ClientDropdown.vue?vue&type=script&lang=ts&"
export * from "./ClientDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports